// TicketStats.tsx
import React, { useMemo } from "react";
import { TicketDetail } from "../services/ticketApiService";

interface TicketStatsProps {
  selectedRows: TicketDetail[];
  totalCount: number;
}

export const TicketStats: React.FC<TicketStatsProps> = ({ selectedRows, totalCount }) => {
  const stats = useMemo(() => {
    return selectedRows.reduce(
      (acc, item) => {
        const qty = Number(item.receivedQty) || 0;
        const isDup = item.duplicatedTicketNumber === true;

        return {
          totalQty: acc.totalQty + qty,
          dupCount: acc.dupCount + (isDup ? 1 : 0),
          dupQty: acc.dupQty + (isDup ? qty : 0),
        };
      },
      { totalQty: 0, dupCount: 0, dupQty: 0 }
    );
  }, [selectedRows]);

  return (
    <div className="flex border-r border-slate-200 dark:border-slate-800 gap-8 px-2 pr-6">
      <div className="flex flex-col">
        <span className="text-xs font-bold text-slate-400 uppercase tracking-widest">Tickets</span>
        <span className="text-lg font-bold text-slate-900 dark:text-white">{totalCount.toLocaleString()}</span>
      </div>
      <div className="flex flex-col">
        <span className="text-xs font-bold text-slate-400 uppercase tracking-widest">Selected</span>
        <span className="text-lg font-bold text-slate-900 dark:text-white">{selectedRows.length}</span>
      </div>
      <div className="flex flex-col">
        <span className="text-xs font-bold text-slate-400 uppercase tracking-widest">Qty</span>
        <span className="text-lg font-bold text-slate-900 dark:text-white">{stats.totalQty.toLocaleString()}</span>
      </div>
      {stats.dupCount > 0 && (
        <>
          <div className="flex flex-col">
            <span className="text-xs font-bold uppercase tracking-widest text-red-500">Duplicate</span>
            <span className="text-lg font-bold text-red-500">{stats.dupCount}</span>
          </div>
          <div className="flex flex-col">
            <span className="text-xs font-bold uppercase tracking-widest text-red-500">Dup Qty</span>
            <span className="text-lg font-bold text-red-500">{stats.dupQty.toLocaleString()}</span>
          </div>
        </>
      )}
    </div>
  );
};